/**
 * SHADOW WIDGET OBSERVER - CHANGELOG
 *
 * Natulim TS - 06-feb-26 CA-4 : Refactorización a función reutilizable + Widget Recharge
 * - PROBLEMA: Código duplicado para observar múltiples widgets con Shadow DOM
 * - SOLUCIÓN: Crear función genérica observeShadowWidget() que acepta configuración
 * - BENEFICIOS:
 *   * Una sola función para manejar todos los widgets con Shadow DOM
 *   * Configuración declarativa mediante objeto de parámetros
 *   * Callback personalizado (onFound) para lógica específica por widget
 *   * Fácil escalabilidad para agregar nuevos widgets
 * - FUNCIONES:
 *   * observeShadowWidget(): Observa y modifica cualquier widget con Shadow DOM
 * - WIDGETS CONFIGURADOS:
 *   * Recharge (recharge-subscription-widget): Estilos flexbox para opciones de compra
 *
 */

function observeShadowWidget(config) {
  const {
    selector,
    targetSelector,
    stylesId,
    styles,
    onFound,
    timeout = 10000
  } = config;
  
  const mainObserver = new MutationObserver(function() {
    const widget = document.querySelector(selector);
    
    if (widget && widget.shadowRoot) {
      const shadowRoot = widget.shadowRoot;
      
      const innerObserver = new MutationObserver(function() {
        const targetElement = shadowRoot.querySelector(targetSelector);
        
        if (targetElement) {
          innerObserver.disconnect();
          
          if (styles && !shadowRoot.querySelector(`#${stylesId}`)) {
            const styleElement = document.createElement('style');
            styleElement.id = stylesId;
            styleElement.textContent = styles;
            shadowRoot.appendChild(styleElement);
          }
          
          if (onFound && typeof onFound === 'function') {
            // Buscar el div padre con el ID de Shopify
            const parentDiv = widget.closest('[id^="shopify-block-"]');
            const containerId = parentDiv ? parentDiv.id : null;
            onFound(shadowRoot, targetElement, widget, containerId);
          }
        }
      });
      
      innerObserver.observe(shadowRoot, {
        childList: true,
        subtree: true
      });
      
      mainObserver.disconnect();
      setTimeout(() => innerObserver.disconnect(), timeout);
    }
  });
  
  mainObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  setTimeout(() => mainObserver.disconnect(), timeout);
}

document.addEventListener('DOMContentLoaded', function() {

  // ─── Widget 1: Recharge Subscription Widget (estilos compra única) ────────
  observeShadowWidget({
    selector: 'recharge-subscription-widget',
    targetSelector: '.rc-purchase-option.rc-selection__onetime',
    stylesId: 'custom-onetime-styles',
    styles: `
      .rc-purchase-option.rc-selection__onetime 
      .rc-purchase-option__label {
        display: flex !important;
        flex-direction: row !important;
        align-items: center !important;
        justify-content: flex-start !important;
        gap: 8px !important;
      }
      .rc-purchase-option.rc-selection__onetime 
      .rc-purchase-option__prices {
        margin-left: 0 !important;
      }
    `
  });

});